import React from "react";
import moment from "moment";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FlexSpacer, Divider, TypeIcon } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUser, faBullseye } from "@fortawesome/free-solid-svg-icons";

import starFilled from "images/marketplace/star-filled.svg";
import starEmpty from "images/marketplace/star-empty.svg";

import styles from "./style.module.css";

export class BlueprintTile extends React.PureComponent {
  render() {
    const { blueprint, purchasedClickHandler, clickHandler, ownerActive, purchased, isMarketplace } = this.props;
    if (blueprint) {
      const details = (blueprint.wizard.marketplace && blueprint.wizard.marketplace.blueprintDetails) || {};
      const parsedBP = {
        id: blueprint.id,
        name: blueprint.name,
        author: (blueprint.created_by && blueprint.created_by.fullname) || "",
        outcome: (blueprint.wizard.dataset && blueprint.wizard.dataset.outcome) || "",
        columns: (blueprint.wizard.dataset && blueprint.wizard.dataset.fields) || {},
        time: moment.utc(blueprint.created_date).local().fromNow(),
        price: details.price || 0,
        priceConditional: details.priceConditional || "",
        priceModifier: details.priceModifier || "",
        rating: details.rating || 0,
        reviews: details.reviews || 0,
        links: details.links || {}
      };
      const tileStyles = getStyles("blueprint");
      return (
        <div className={styles.cardWrapper}>
          <div className={styles.card} onClick={() => clickHandler()}>
            <div className={styles.cardHeader + " " + tileStyles.background}>
              <div className={styles.cardName + " " + tileStyles.text}>{parsedBP.name}</div>
              <div className={styles.cardText + " " + styles.timeText}>{parsedBP.time}</div>
              <FlexSpacer />
              <div className={styles.cardHeaderInfo}>
                <div className={styles.cardHeaderCol}>
                  <div className={styles.cardHeaderNum}>{Object.keys(parsedBP.columns).length}</div>
                  <OverlayTrigger
                    placement="top"
                    trigger={["click"]}
                    rootClose
                    overlay={
                      <Popover id={"blueprint-column-" + parsedBP.id} title={"Columns"}>
                        <div className={styles.popList}>
                          {Object.keys(parsedBP.columns).map((field, i) => (
                            <div key={field} className={styles.popRow}>
                              {field}
                            </div>
                          ))}
                        </div>
                      </Popover>
                    }
                  >
                    <div className={styles.popTrigger} onClick={(event) => event.stopPropagation()}>
                      <a>{"Columns"}</a>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            <div className={styles.cardBody}>
              <div className={styles.cardBodyInfo}>
                <div className={styles.cardBodyIcon}>
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <p>{parsedBP.author}</p>
              </div>
              <div className={styles.cardBodyInfo}>
                <div className={styles.cardBodyIcon}>
                  <FontAwesomeIcon icon={faBullseye} />
                </div>
                <p>{parsedBP.outcome}</p>
              </div>
              <MarketplaceInfo isMarketplace={isMarketplace} {...parsedBP} />
            </div>
          </div>
          <PurchasedOverlay
            ownerActive={ownerActive}
            purchased={purchased}
            isMarketplace={isMarketplace}
            purchasedClickHandler={purchasedClickHandler}
          />
        </div>
      );
    } else return false;
  }
}

export class ModelTile extends React.PureComponent {
  render() {
    const { model, purchasedClickHandler, clickHandler, ownerActive, purchased, isMarketplace } = this.props;
    if (model) {
      const details = (model.wizard.marketplace && model.wizard.marketplace.modelDetails) || {};
      const parsedModel = {
        id: model.id,
        label: model.label,
        name: model.name,
        author: (model.created_by && model.created_by.fullname) || "",
        price: details.price || 0,
        priceConditional: details.priceConditional || "",
        priceModifier: details.priceModifier || "",
        rating: details.rating || 0,
        reviews: details.reviews || 0,
        links: details.links || {}
      };
      const tileStyles = getStyles("model");
      return (
        <div className={styles.cardWrapper}>
          <div className={styles.card} onClick={() => clickHandler()}>
            <div className={styles.cardHeader + " " + tileStyles.background}>
              <div className={styles.cardName + " " + tileStyles.text}>{parsedModel.name}</div>
              <FlexSpacer />
              <div className={styles.cardHeaderInfo}>
                <div className={styles.cardHeaderIcon}>
                  <TypeIcon type={"model"} size={"80px"} padding={"0px"} />
                </div>
              </div>
            </div>

            <div className={styles.cardBody}>
              <div className={styles.cardBodyInfo}>
                <div className={styles.cardBodyIcon}>
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <p>{parsedModel.author}</p>
              </div>
              <MarketplaceInfo isMarketplace={isMarketplace} {...parsedModel} />
            </div>
          </div>
          <PurchasedOverlay
            ownerActive={ownerActive}
            purchased={purchased}
            isMarketplace={isMarketplace}
            purchasedClickHandler={purchasedClickHandler}
          />
        </div>
      );
    } else return false;
  }
}

export class DatasetTile extends React.PureComponent {
  render() {
    const { dataset, purchasedClickHandler, clickHandler, ownerActive, purchased, isMarketplace } = this.props;
    if (dataset) {
      const details = (dataset.wizard.marketplace && dataset.wizard.marketplace.datasetDetails) || {};
      const parsedDataset = {
        id: dataset.id,
        name: dataset.name,
        author: (dataset.created_by && dataset.created_by.fullname) || "",
        price: details.price || 0,
        priceConditional: details.priceConditional || "",
        priceModifier: details.priceModifier || "",
        rating: details.rating || 0,
        reviews: details.reviews || 0,
        links: details.links || {}
      };
      const tileStyles = getStyles("dataset");
      return (
        <div className={styles.cardWrapper}>
          <div className={styles.card} onClick={() => clickHandler()}>
            <div className={styles.cardHeader + " " + tileStyles.background}>
              <div className={styles.cardName + " " + tileStyles.text}>{parsedDataset.name}</div>
              <FlexSpacer />
              <div className={styles.cardHeaderInfo}>
                <div className={styles.cardHeaderIcon}>
                  <img src={tileStyles.image} alt="dataset" />
                </div>
              </div>
            </div>

            <div className={styles.cardBody}>
              <div className={styles.cardBodyInfo}>
                <div className={styles.cardBodyIcon}>
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <p>{parsedDataset.author}</p>
              </div>
              <MarketplaceInfo isMarketplace={isMarketplace} {...parsedDataset} />
            </div>
          </div>
          <PurchasedOverlay
            ownerActive={ownerActive}
            purchased={purchased}
            isMarketplace={isMarketplace}
            purchasedClickHandler={purchasedClickHandler}
          />
        </div>
      );
    } else return false;
  }
}

export class ConsultingTile extends React.PureComponent {
  render() {
    const { consulting, purchasedClickHandler, clickHandler, ownerActive, purchased, isMarketplace } = this.props;
    if (consulting) {
      const details = (consulting.wizard.marketplace && consulting.wizard.marketplace.consultingDetails) || {};
      const parsedConsulting = {
        id: consulting.id,
        name: consulting.name,
        author: (consulting.created_by && consulting.created_by.fullname) || "",
        price: details.price || 0,
        priceConditional: details.priceConditional || "",
        priceModifier: details.priceModifier || "",
        rating: details.rating || 0,
        reviews: details.reviews || 0,
        links: details.links || {}
      };
      const tileStyles = getStyles("consulting");
      return (
        <div className={styles.cardWrapper}>
          <div className={styles.card} onClick={() => clickHandler()}>
            <div className={styles.cardHeader + " " + tileStyles.background}>
              <div className={styles.cardName + " " + tileStyles.text}>{parsedConsulting.name}</div>
              <FlexSpacer />
              <div className={styles.cardHeaderInfo}>
                <div className={styles.cardHeaderIcon}>
                  <img src={tileStyles.image} alt="consulting" />
                </div>
              </div>
            </div>

            <div className={styles.cardBody}>
              <div className={styles.cardBodyInfo}>
                <div className={styles.cardBodyIcon}>
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <p>{parsedConsulting.author}</p>
              </div>
              <MarketplaceInfo isMarketplace={isMarketplace} {...parsedConsulting} />
            </div>
          </div>
          <PurchasedOverlay
            ownerActive={ownerActive}
            purchased={purchased}
            isMarketplace={isMarketplace}
            purchasedClickHandler={purchasedClickHandler}
          />
        </div>
      );
    } else return false;
  }
}

export class CreateTile extends React.PureComponent {
  render() {
    const { type, clickHandler } = this.props;
    const tileStyles = getStyles(type);
    return (
      <div className={styles.cardWrapper}>
        <div className={styles.card} onClick={() => clickHandler()}>
          <div className={styles.cardHeader + " " + tileStyles.background}>
            <div className={styles.cardName + " " + tileStyles.text} style={{ textTransform: "capitalize" }}>
              {type !== "consulting" ? type : "Expertise"}
            </div>
            <FlexSpacer />
            <div className={styles.cardHeaderInfo}>
              <div className={styles.cardHeaderIcon}>
                <img src={tileStyles.image} alt={type} />
              </div>
            </div>
          </div>

          <div className={styles.cardBody}>
            <div className={styles.cardCreate}>
              <h2>Create New</h2>
              <h1 className={tileStyles.text}>
                <FontAwesomeIcon icon={faPlus} />
              </h1>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class MarketplaceInfo extends React.PureComponent {
  render() {
    const { isMarketplace, price, priceConditional, priceModifier, rating, reviews, links } = this.props;
    if (isMarketplace) {
      const linkedTypes = Object.keys(links);
      return (
        <React.Fragment>
          <div className={styles.ratingWrapper}>
            <div className={styles.starWrapper}>
              {[0, 1, 2, 3, 4].map((i) => (
                <img key={i} src={rating > i ? starFilled : starEmpty} alt="Rating Star" />
              ))}
            </div>
            <p>
              {reviews} review{parseInt(reviews) !== 1 ? "s" : ""}
            </p>
          </div>
          <div className={styles.price}>{price > 0 ? "$" + parseFloat(price).toFixed(2) + priceModifier : "Free"}</div>
          {priceConditional ? <div className={styles.priceConditional}>{priceConditional}</div> : false}
          <FlexSpacer />
          {linkedTypes.length > 0 && (
            <React.Fragment>
              <Divider />
              <div className={styles.linkedItemWrapper}>
                {linkedTypes.map((type, i) =>
                  links[type] && links[type].length > 0 ? (
                    <div key={type + i} className={styles.linkedItem}>
                      <TypeIcon type={type} border size={"24px"} num={links[type].length} />
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    } else return false;
  }
}

class PurchasedOverlay extends React.PureComponent {
  render() {
    const { purchasedClickHandler, ownerActive, purchased } = this.props;
    return purchased || ownerActive ? (
      <div
        className={styles.purchasedOverlay}
        onClick={(e) => {
          e.stopPropagation;
          return purchasedClickHandler();
        }}
      >
        {!ownerActive && <div className={styles.purchasedIndicator}>Purchased</div>}
      </div>
    ) : (
      false
    );
  }
}
